// A-quattuor.6 F1-d: busca de produto/serviço sem acento — fonte única (molde: customerSearch.ts).
// As RPCs search_products_fuzzy e search_services_fuzzy (unaccent + casamento por palavra, gate M5)
// devolvem os ids; os hooks que ainda faziam `.ilike` direto no PostgREST seguem filtrando
// `.in('id', ids)`, o que preserva select/paginação (.range + count)/order de cada tela.
// Atenção: as RPCs só devolvem registros ATIVOS (active = true).
import { supabase } from '@/integrations/supabase/client';

/** Teto alinhado ao helper de clientes (FUZZY_ID_LIMIT). */
export const PRODUCT_FUZZY_ID_LIMIT = 5000;

export async function searchProductIdsFuzzy(
  companyId: string,
  term: string,
  limit: number = PRODUCT_FUZZY_ID_LIMIT,
  productType?: string | null,
): Promise<string[]> {
  const trimmed = term.trim();
  if (!trimmed) return [];
  const { data, error } = await supabase.rpc('search_products_fuzzy', {
    p_company_id: companyId, // decorativo: a RPC reatribui pelo caller (M5)
    p_search_term: trimmed,
    p_product_type: productType ?? null,
    p_limit: limit,
    p_offset: 0,
  });
  if (error) throw error;
  return (data ?? []).map((row) => row.id);
}

export async function searchServiceIdsFuzzy(
  companyId: string,
  term: string,
  limit: number = PRODUCT_FUZZY_ID_LIMIT,
): Promise<string[]> {
  const trimmed = term.trim();
  if (!trimmed) return [];
  // types.ts não regenerado nesta sessão: RPC nova chamada com cast no nome.
  const { data, error } = await supabase.rpc('search_services_fuzzy' as any, {
    p_company_id: companyId, // decorativo: a RPC reatribui pelo caller (M5)
    p_search_term: trimmed,
    p_limit: limit,
    p_offset: 0,
  });
  if (error) throw error;
  return ((data ?? []) as { id: string }[]).map((row) => row.id);
}
